import type { PicShowPresetKind } from '@/events/palette/eventPalette'
import type EventPicShow from '@/model/EventClass/EventPicShow'

const PIC_SHOW_PRESET_MAP = new WeakMap<EventPicShow, PicShowPresetKind>()

export function setPicShowPreset(event: EventPicShow, preset?: PicShowPresetKind) {
  if (!preset) {
    PIC_SHOW_PRESET_MAP.delete(event)
    return
  }
  PIC_SHOW_PRESET_MAP.set(event, preset)
}

export function getPicShowPreset(event: EventPicShow): PicShowPresetKind | undefined {
  return PIC_SHOW_PRESET_MAP.get(event)
}
